import { useState } from "react";
import { X } from "lucide-react";
import { apiAuth } from "@/lib/api";

export const StatusChangeModal = ({
  open, onClose, onSaved, entityType, entityId, currentStatus, options,
}) => {
  const [status, setStatus] = useState(currentStatus || options[0]);
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  if (!open) return null;

  const save = async (e) => {
    e.preventDefault();
    setSaving(true); setError(null);
    try {
      await apiAuth.patch(`/admin/${entityType}s/${entityId}/status`, {
        status, reason: reason.trim() || null,
      });
      onSaved?.(status);
      onClose();
    } catch (_e) {
      setError("Status konnte nicht geändert werden.");
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 bg-cocoa/40 flex items-center justify-center z-50 p-5" onClick={onClose}>
      <form
        onSubmit={save}
        className="bg-white border border-sandBeige rounded-3xl p-6 max-w-md w-full shadow-soft"
        onClick={(e) => e.stopPropagation()}
        data-testid="status-change-modal"
      >
        <div className="flex justify-between items-center mb-5">
          <p className="font-serif text-xl text-cocoa">Status ändern</p>
          <button type="button" onClick={onClose} aria-label="Schließen"><X size={18} /></button>
        </div>
        <label className="flex flex-col gap-1.5 mb-4">
          <span className="text-xs font-medium text-cocoa">Neuer Status</span>
          <select
            className="wit-input"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            data-testid="status-modal-select"
          >
            {options.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
        <label className="flex flex-col gap-1.5 mb-5">
          <span className="text-xs font-medium text-cocoa">Begründung (optional)</span>
          <textarea
            className="wit-input resize-none" rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            data-testid="status-modal-reason"
          />
        </label>
        {error && <p className="text-sm text-coral mb-3">{error}</p>}
        <div className="flex gap-3 justify-end">
          <button type="button" onClick={onClose} className="wit-btn-secondary">Abbrechen</button>
          <button type="submit" disabled={saving} className="wit-btn-primary disabled:opacity-60" data-testid="status-modal-save">
            {saving ? "Speichern …" : "Speichern"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default StatusChangeModal;
